import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-900 mx-auto"></div>
          <p className="mt-4 text-blue-900 font-medium">Carregando...</p>
        </div>
      </div>
    );
  }

  const isUserValid = Boolean(user && typeof user === 'object' && !Array.isArray(user) && (user.user_id || user.email));
  if (!isAuthenticated || !isUserValid) {
    return <Navigate to="/" replace />;
  }

  return children;
};

